class SalesInvoiceLineCell extends InvoiceLineCell
{
    get entityName() : string { return "SalesInvoiceLine"; }
    
    protected productDidSelect( controller:SelectEntityViewController, product:Product, supplierProduct?:SupplierProduct )
    {
        super.productDidSelect(controller, product, supplierProduct);
        
        this.vat = this.taxForProduct(product);
        this.updateTaxUI();
    }

    // The sale tax of the product (its tax, else its category's).
    protected taxForProduct(product:Product) : Tax {
        return product.tax ?? product.category?.tax;
    }
}
